<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 388 512"
			class="icon-file-pdf"
		>
			<path
				opacity=".4"
				class="duotone"
				d="M249.4 0l69.2 69.2 69.2 69.2-110.7 0c-15.3 0-27.7-12.4-27.7-27.7L249.4 0z"
			/>
			<path
				class="duotone"
				d="M.3 27.7C.3 12.4 12.7 0 27.9 0L249.4 0l0 110.7c0 15.3 12.4 27.7 27.7 27.7l110.7 0 0 345.9c0 15.3-12.4 27.7-27.7 27.7L27.9 512C12.7 512 .3 499.6 .3 484.3L.3 27.7zM178.2 206.5c1.1-8.5 1.6-16.2 1.5-22.7c-.3-12.8-2.2-23.4-5.1-31.2c-1.4-3.9-3.4-7.7-5.9-10.8c-2.2-2.7-6.8-7.1-13.8-7.4c-8.2-.3-13.3 5.1-15.6 9.1c-2.2 3.9-3.1 8.3-3.4 12.3c-.7 8.1 .5 18.9 3.9 31.8c1.7 6.3 5.2 14.6 9.8 23.8c-3.5 21.2-10.3 48.1-18.5 74.5c-4.2 13.5-8.8 26.6-13.3 38.3c-8.9 3.7-16.9 8-23.6 12.7C76.7 349.4 67.2 367.4 72.8 383c3 8.4 10.6 14.8 20.6 14.9c9.1 .1 17.1-4.9 23.2-11.5c6.9-7.4 14.1-21.4 20.6-36.7c.5-1.3 1.1-2.6 1.7-3.9c9.9-3.3 21.1-6.2 33.3-8.4c19.5-3.5 40.5-5.1 60.4-4.4c5 5.2 9.9 9.6 14.4 12.8c8.3 5.9 16.9 9.4 25 9.5c7.9 0 18.4-3.8 21.1-15c2.5-10.3-3.6-18.7-9.6-23.4c-6.5-5-15.6-8.3-26.7-9.7c-3.7-.5-7.5-.9-11.3-1.2c-2.3-2.7-4.8-5.6-7.3-8.8c-10.1-12.4-20.9-27.5-31.1-42.9s-19.6-30.9-26.9-44.2c-.7-1.2-1.3-2.4-1.9-3.5zm-8 41.5c4.3 7.1 9 14.3 13.7 21.5c8.2 12.4 16.9 24.7 25.4 35.8c-14.3 .7-28.5 2.3-42.1 4.7c-5.5 1-11 2.1-16.3 3.4c2.2-6.3 4.3-12.8 6.4-19.4c4.7-15.1 9.2-30.9 12.8-46.1zm96.8 91.1s0 0 0 0s0 0 0 0s0 0 0 0l0 0c0 0 0 .1 0 .1z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from '../Icon'
export default {
	name: 'AdobePDFIcon',
	components: { Icon },
	props,
}
</script>
<style scoped>
svg path {
	fill: #f74a4a !important;
}
</style>
